import React from 'react';

const About = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-red-600 to-red-700 text-white py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">About IndyaNet</h1>
          <p className="text-xl text-red-100">Transforming Connectivity Across India</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-gray-100 relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-5 pointer-events-none"
          style={{
            backgroundImage:
              'url(https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=1600&q=80)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        ></div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100">
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              At IndyaNet, we are dedicated to building the digital backbone for enterprises across India. Founded by
              a team of passionate network and technology experts, our mission is to empower businesses with reliable,
              secure, and high-performance network solutions.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              We understand that in today's hyper-connected world, seamless communication and fast data flow are
              critical. That's why we provide not just internet connectivity, but comprehensive network infrastructure
              that drives productivity and innovation.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              With our customer-first approach, industry-leading technologies, and 24/7 support, IndyaNet is trusted
              by organizations of all sizes to keep their business connected and future-ready.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;